import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import 'zone.js';
import { Mutex } from 'async-mutex';
import * as Msal from 'msal';
import { dialogFallback } from './helpers/fallbackauthhelper';

import './styles.scss';

const mutex = new Mutex();

if (process.env['APPSETTING_ENV'] === 'PRODUCTION') {
  enableProdMode();
  console.debug = () => {};
}

export function startApp() {
  let element = document.getElementById('login-container');
  if (element !== null) {
    element.className = 'd-none';
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((error) => console.error(error));
  }
}

const msalConfig: Msal.Configuration = {
  auth: {
    clientId: '4dfd3b9f-60db-4838-bb62-2505606179cb', //This is your client ID
    authority:
      'https://login.microsoftonline.com/ebb24e74-d367-4ff2-8906-5559fc0c8078',
    redirectUri: process.env['APPSETTING_REDIRECT_URI'],
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage', // Needed to avoid "User login is required" error.
    storeAuthStateInCookie: true, // Recommended to avoid certain IE/Edge issues.
  },
};

const userAgentApp: Msal.UserAgentApplication = new Msal.UserAgentApplication(
  msalConfig
);
const loginRequest: any = {
  scopes: [`https://graph.microsoft.com/User.Read`],
  loginHint: null,
  authority: userAgentApp.authority,
};

async function fallBackAuth(request) {
  if (userAgentApp.getAccount()) {
    try {
      request.loginHint =
        userAgentApp.getAccount().idToken['preferred_username'];

      await userAgentApp.ssoSilent(request);
      await userAgentApp.acquireTokenSilent(request).then((response) => {
        window.OAuthToken = response.accessToken;
        window.expiresOn = response.expiresOn;
        localStorage.setItem('feeder_sso', JSON.stringify(true));
        startApp();
      });
    } catch (error) {
      dialogFallback();
    }
  } else {
    dialogFallback();
  }
}

window.officeInitialized = false;
Office.onReady((info) => {
  mutex.runExclusive(() => {
    if (window.officeInitialized) {
      return;
    }
    window.officeInitialized = true;

    const btnSSO = document.getElementById('btn-login-sso');
    const btnApiKey = document.getElementById('btn-login-api-key');
    btnSSO!.addEventListener('click', () => {
      loginSSO(Office.context);
    });
    btnApiKey!.addEventListener('click', () => {
      loginApiKey();
    });

    const isSSO = JSON.parse(localStorage.getItem('feeder_sso') ?? 'false');
    if (isSSO) {
      loginSSO(info);
    } else {
      const element = document.getElementById('login-container');
      if (element !== null) {
        element.className =
          'd-flex w-100 h-100 justify-content-center align-items-center';
        let apiKey = localStorage.getItem('feeder_api_key');
        if (apiKey !== null) {
          const apiKeyInput = document.getElementById('input-api-key');
          if (apiKeyInput !== null) {
            apiKeyInput.setAttribute('value', apiKey);
          }
        }
      }
    }
  });
});

async function loginSSO(info?) {
  try {
    // Try silent authentication first
    const response = await userAgentApp.acquireTokenSilent(loginRequest);
    window.OAuthToken = response.accessToken;
    window.expiresOn = response.expiresOn;
    localStorage.setItem('feeder_sso', JSON.stringify(true));
    startApp();
  } catch (error) {
    console.error('Silent auth failed, trying popup:', error);
    fallBackAuth(loginRequest);
  }
  if (
    info.platform === Office.PlatformType.OfficeOnline ||
    info.platform === Office.PlatformType.PC
  ) {
    Excel.run(async (context) => {
      let range = context.workbook.worksheets
        .getActiveWorksheet()
        .getUsedRange()
        .getSpecialCellsOrNullObject(Excel.SpecialCellType.formulas);
      range.load(['address']);
      await context.sync();
      if (!range.isNullObject) {
        range.calculate();
      }
      return context.sync();
    }).catch((error) => {
      console.error(error);
    });
  }
}
function loginApiKey() {
  localStorage.setItem('feeder_sso', JSON.stringify(false));
  let apiKey = document.getElementById('input-api-key') as HTMLInputElement;
  if (apiKey !== null && apiKey.value !== '') {
    localStorage.setItem('feeder_api_key', apiKey.value);
  }
  startApp();
}
